import { render, staticRenderFns } from "./AdminUserAddresses.vue?vue&type=template&id=125e76b9&scoped=true"
import script from "./AdminUserAddresses.vue?vue&type=script&lang=js"
export * from "./AdminUserAddresses.vue?vue&type=script&lang=js"
import style0 from "./AdminUserAddresses.vue?vue&type=style&index=0&id=125e76b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e76b9",
  null
  
)

export default component.exports